// gantt-timeline-header.component.ts
import * as angular from "angular";
import { GanttTimelineUnit, GanttWeekRange } from "../../../models/gantt.model";

let GanttTimelineHeaderComponent = {
    selector: "vcGanttTimelineHeader",
    templateUrl:
        "/angular/components/planner/gantt-chart/gantt-timeline-header.component.html",
    bindings: {
        count: "<", // number
        timeline: "<", // GanttTimelineUnit[]
        cellWidth: "<", // number
        viewMode: "<",
        lanes: "<",
    },
    controller: class GanttTimelineHeaderController {
        public count: number;
        public timeline: GanttTimelineUnit[] = [];
        public cellWidth: number = 60;
        public lanes: number = 0;
        public viewMode: "days" | "weeks" | "months" | "quarters" = "days";
        public weekRanges: GanttWeekRange[] = [];

        private readonly $element: any;
        private readonly $timeout: any;

        constructor($element: any, $timeout: any) {
            this.$element = $element;
            this.$timeout = $timeout;
        }

        $onInit() {
            this.timeline = this.timeline || [];
            this.cellWidth = this.cellWidth || 60;
            this.lanes = this.lanes || 60;
            this.processTimelineForDaysView();
        }

        $onChanges(changes: any) {
            if (changes.timeline || changes.viewMode) {
                this.processTimelineForDaysView();
            }
        }
        public scrollToClass(className: string): void {
            this.$timeout(() => {
                const host = this.$element[0] as HTMLElement;
                const target = host.querySelector(
                    "." + className
                ) as HTMLElement | null;

                if (target) {
                    target.scrollIntoView({
                        block: "center", // or "center" / "nearest"
                        inline: "center",
                    });
                }
            });
        }
        private processTimelineForDaysView(): void {
            if (this.viewMode === "days" && this.timeline.length > 0) {
                this.generateWeekRanges();
            }

            this.scrollToClass("today");
        }

        private generateWeekRanges(): void {
            if (!this.timeline.length) return;

            this.weekRanges = [];
            const thisYear = new Date().getFullYear();
            let currentWeekStart: Date | null = null;
            let currentWeekEnd: Date | null = null;
            let dayCount = 0;

            this.timeline.forEach((unit: GanttTimelineUnit, index: number) => {
                const currentDate = new Date(unit.date);
                const dayOfWeek = currentDate.getDay();
                let yearOfWeek = currentDate.getFullYear();

                // Start of a new week (Sunday = 0) or first day
                if (dayOfWeek === 0 || index === 0) {
                    // Save previous week if exists
                    if (currentWeekStart && currentWeekEnd) {
                        this.weekRanges.push({
                            label: this.formatWeekRange(
                                currentWeekStart,
                                currentWeekEnd,
                                thisYear != yearOfWeek ? String(yearOfWeek) : ""
                            ),
                            dayCount: dayCount,
                            startDate: currentWeekStart,
                            endDate: currentWeekEnd,
                        });
                    }

                    // Start new week
                    currentWeekStart = new Date(currentDate);
                    dayCount = 1;
                } else {
                    dayCount++;
                }

                currentWeekEnd = new Date(currentDate);

                yearOfWeek = currentDate.getFullYear();
                // Handle last day
                if (index === this.timeline.length - 1) {
                    this.weekRanges.push({
                        label: this.formatWeekRange(
                            currentWeekStart!,
                            currentWeekEnd,
                            String(yearOfWeek)
                        ),
                        dayCount: dayCount,
                        startDate: currentWeekStart!,
                        endDate: currentWeekEnd,
                    });
                }
            });
        }

        private formatWeekRange(
            startDate: Date,
            endDate: Date,
            year: string
        ): string {
            const formatOptions: Intl.DateTimeFormatOptions = {
                month: "short",
                day: "numeric",
            };

            const start = startDate.toLocaleDateString("en-US", formatOptions);
            const end = endDate.toLocaleDateString("en-US", formatOptions);

            // If same month, show "Jan 29 - Feb 4", if different months show "Jan 29 - Feb 4"
            return `${start} - ${end} ${year}`;
        }

        public getTimelineWidth(): number {
            return this.timeline.length * this.cellWidth;
        }

        public getTodayLineStyle(): any {
            const height = this.lanes * 51;
            return {
                height: height + "px",
                bottom: "-" + height + "px",
            };
        }
    },
};

angular
    .module("planner")
    .component(
        GanttTimelineHeaderComponent.selector,
        GanttTimelineHeaderComponent
    );
